import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

import { Button, Box, Flex, Select } from "@mantine/core";
import SRD_DataTable from "components/DataTable";
import { getDeviceList } from "../apis/adminDeviceApis";
import { getGroupList } from "pages/Admin/Group/apis/adminGroupApis";
import { useQuery } from "react-query";
import { PAGE_SIZE } from "CommonData";
import { useRecoilState } from "recoil";
import { userState } from "pages/Login/atom/userState";

function DeviceDataTable() {
  const navigate = useNavigate();
  const [user] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const isSuperAdmin = [0].includes(level);
  const userGroupId = user?.fn_group_id ? String(user.fn_group_id) : undefined;
  const ALL_GROUP = "ALL";
  const [searchparams, setSearchparams] = useSearchParams();

  const location = useLocation();   //add bjkim6114
  let pg = 1;
  if (location.state ) {   
     pg = location.state.pg;
  } 
  const defaultGroupValue = useMemo(() => {
    if (location.state?.group) return location.state.group;
    if (isSuperAdmin) return ALL_GROUP;
    return userGroupId;
  }, [isSuperAdmin, location.state?.group, userGroupId]);

  const page = Number(searchparams.get("page")) || 1;
  const group = searchparams.get("group") ?? defaultGroupValue;

  const setPage = (newPage) => {
    const next = new URLSearchParams(searchparams);
    if (newPage){
      next.set("page", String(newPage));
    }
    else {
      next.set("page", "1");
    }
    setSearchparams(next);
  };

  const setGroup = (newGroup) => {
    const next = new URLSearchParams(searchparams);
    if (newGroup) {
      next.set("group", newGroup);
    } else {
      next.delete("group");
    }
    next.set("page", "1");
    setSearchparams(next);
  };

  const { data: groupListData } = useQuery(
    "deviceGroupList",
    () =>
      getGroupList(1000, 1).then((res) =>
        res.map((item) => ({
          value: String(item.group_id),
          label: item.group_nm,
        }))
      ),
    {
      staleTime: 5 * 60 * 1000,
    }
  );

  const adminOption = { value: ALL_GROUP, label: "전체 그룹" };

  const groupOptions = useMemo(() => {
    if (!groupListData || groupListData.length < 1) {
      if (!isSuperAdmin && userGroupId) {
        return [
          { value: userGroupId, label: user?.fn_group_nm ?? "소속 그룹" },
        ];
      }
      return isSuperAdmin ? [adminOption] : [];
    }

    const options = [...groupListData];

    if (isSuperAdmin) {
      const hasAll = options.some((option) => option.value === ALL_GROUP);
      return hasAll ? options : [adminOption, ...options];
    }

    return options.filter((option) => option.value === userGroupId);
  }, [groupListData, isSuperAdmin, userGroupId, user?.fn_group_nm]);

  const selectedGroupId =
    group === ALL_GROUP || group === undefined ? null : group;

  const canFetchList = group !== undefined || isSuperAdmin;

  const { data } = useQuery(
    ["deviceLists", page, selectedGroupId],
    () => getDeviceList(PAGE_SIZE, page, selectedGroupId),
    {
      keepPreviousData: true,
      enabled: canFetchList,
    }
  );

  const columns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => record?.rnum,
    },
    {
      accessor: "group_nm",
      title: "소속그룹",
    },
    {
      accessor: "bsd_nm",
      title: "장치명",
      cellsStyle: {
        color: "blue",
//        textDecoration: "underline",
      },
      onClick: function (e) {
        navigate(`/admin/device/${e.record.bsd_id}`,{
          state: {
            pg: page,
            group,
          }
        }
      )},
    },
    {
      accessor: "devcie_status",
      title: "장치상태",
      render: ({ devcie_status }) => (
        <Box c={devcie_status === "통신 정상" ? "black" : "red"}>
          {devcie_status}
        </Box>
      ),
    },
    {
      accessor: "cntlr_id",
      title: "장치 고유번호",
    },
    {
      accessor: "model_nm",
      title: "모델명",
    },
    {
      accessor: "regist_dt",
      title: "등록일자",
    },
    {
      accessor: "instl_lc",
      title: "설치위치",
    },
    {
      accessor: "rm",
      title: "비고",
    },
  ];

  const RegisterButton = () => {
    return (
      <Button variant="default" onClick={() => navigate("/admin/device/add", {state: {pg: page, group}})}>
        등록관리
      </Button>
    );
  };

  const SearchBar = () => {
    const handleGroupChange = (value) => {
      if (!isSuperAdmin) return;
      setGroup(value ?? ALL_GROUP);
    };

    return (
      <Flex gap={15} mb={10} align="center" style={{ width: "100%" }}>
        <Select
          data={groupOptions ?? []}
          value={group ?? undefined}
          placeholder="그룹선택"
          onChange={handleGroupChange}
          disabled={!isSuperAdmin}
          style={{ flex: 1 }}
        />
        <RegisterButton />
      </Flex>
    );
  };

  return (
    <SRD_DataTable
      searchBar={<SearchBar />}
      data={data ?? []}
      columns={columns}
      page={page}
      setPage={setPage}
    />
  );
}

export default DeviceDataTable;
